import styled from "styled-components";

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* @media (max-width: 768px) {
    justify-content: space-between;
  } */
`;

const IconsContainer = styled.div`
  margin: 10px 30px 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    margin: 10px 0 10px 20px;
  }
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin: 0 2px;
`;

const XIcon = styled(Icon)`
  width: 38px;
  height: 28px;
`;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0 10px 0;
  @media (max-width: 768px) {
    margin: 10px 0 10px 0;
  }
`;

const Footer = () => {
  return (
    <>
      <FooterContainer>
        {/* <IconsContainer>
          <Icon src="./facebook.png" alt="Facebook" />
          <XIcon src="./x.png" alt="X" />
          <Icon src="./instagram.png" alt="Instagram" />
        </IconsContainer> */}
        <ContactContainer>
          <div>tel: 734 308 772</div>
          <div>fama@fama.cz</div>
        </ContactContainer>
      </FooterContainer>
    </>
  );
};

export default Footer;
